module.exports = __webpack_public_path__ + "static/media/checkBox.19966f91.svg";